
<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="hidden md:block navbar-custom navbar-skelton py-2 px-16" style="background: #f7f7f7">
      <div class="vx-row justify-between w-full" id="logo-container">

        <div class="vx-col md:w-1/2 lg:w-1/2 flex flex-start items-center text-left">
          <a :href="linkApp" target="_blank" class="cursor-pointer md:mx-auto lg:mx-0 text-left flex items-center text-grey">
            <small class="mr-2">
              <feather-icon icon="SmartphoneIcon"></feather-icon>  
            </small>
            <small>Download ZX App</small>
          </a>
        </div>
        <div class="vx-col md:w-1/2 lg:w-1/2">
          <ul class="flex justify-end">
            <li class="mx-4"><router-link to="/about" class="text-grey"><small>Tentang ZX</small></router-link></li>
            <li class="mx-4"><router-link to="/sahabat-zx" class="text-grey"><small>Sahabat ZX</small></router-link></li>
            <li class="mx-4"><router-link to="/promo" class="text-grey"><small>Promo</small></router-link></li>
            <li class="mx-4"><router-link to="/zxcare" class="text-grey"><small>ZX Care</small></router-link></li>
          </ul>
        </div>

      </div>
    </vs-navbar>
    <vs-navbar class="navbar-custom navbar-skelton bg-primary px-16" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">

      <div class="vx-row justify-between w-full" id="logo-container">
        <div class="vx-col md:w-1/2 lg:w-2/3 flex items-center">
          <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center lg:mr-4">
            <img src="/assets/images/footer/logozx.svg" class="logo w-12 md:w-24 lg:w-24 md:py-2" alt=""  />
          </router-link>
          <div class="flex items-center w-full">
            <span class="text-white mr-4">Cari</span>
            <div class="flex items-center w-full relative cari" >
              <input
                  type="text" 
                  class="w-full px-4 py-1 rounded"
                  style="border: 3px solid white"
                  v-model="searchQuery"
                  @keyup.enter="search"
              />
              <vs-button 
                  color="warning" 
                  size="small"
                  class="rounded-none px-4 absolute"
                  style="right:0;"
                  icon-pack="feather"
                  icon="icon-search"
              >
              </vs-button>
            </div>
            <!-- <vs-input class="w-full p-0 rounded ml-6 border-dark bg-grey grey lg:w-full" id="main-search" icon-pack="feather" icon="icon-search" icon-after style="background: #eee;" /> -->  
          </div>
          
        </div>

        <main class="vx-col md:w-1/2 lg:w-1/3 flex items-center justify-end p-0">
          <notification-drop-down /> 
          <message-drop-down />
          <sahabat-zx />
          <div class="text-white">|</div>
          <profile-drop-down /> 
        </main>        
      </div>
      

    </vs-navbar>
  </div>
</div>
</template>

<script>
import MessageDropDown from './components/MessageDropDown.vue'
import NavbarMenu           from './components/MenuHorizontal.vue'
import Bookmarks            from './components/Bookmarks.vue'
import CartDropDown         from './components/CartDropDown.vue'
import SahabatZx            from './components/SahabatZX.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Logo                 from '../Logo.vue'
import index from '@/assets/utils/index'

export default {
  name: 'the-navbar-horizontal',
  data: () => ({
    searchQuery: null
  }),
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    MessageDropDown,
    NavbarMenu,
    Logo,
    Bookmarks,
    CartDropDown,
    SahabatZx,
    NotificationDropDown,
    ProfileDropDown
  },
  methods: {
    search() {
      if(this.searchQuery.length < 3) {
        this.$vs.notify({
          title: 'Pencarian minimal 3 karakter',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      if(this.$route.query.q != this.searchQuery) {
        if(this.searchQuery && this.searchQuery.length >= 3) {
          this.$router.push(`/search?q=${this.searchQuery.toLowerCase()}`)
        }
      }
        
    }
  },
  computed: {
    linkApp() {
      return index.linkApp
    },
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  }
}

</script>
<style>
  .vs-con-items {
    justify-content: space-between;
  }
  .cari .icon-search {
    color: #045532;
  }
</style>